import React, { useMemo, useState } from 'react'
// import { SlEye } from 'react-icons/sl'
import { FaPlus } from 'react-icons/fa6'
import PadContainer from '../../../components/PadContainer'
import TitleContainer from '../../../components/TitleContainer'
import { Avatar, Button, Divider, Drawer, Dropdown, Form, Image, Input, Switch, Tag, Upload, notification } from 'antd'
import eventImage from '../../../assets/gallery/event.png'
import { handleConfirm, handleTableSelect, statusType } from '../../../context/utils'
import CustomTable from '../../../components/CustomTable'
import { PiDotsThreeOutlineBold } from 'react-icons/pi'
import { BiEdit, BiUser } from 'react-icons/bi'
// import { LuFileUp } from 'react-icons/lu'
import { GoTrash } from 'react-icons/go'
import { ImStopwatch } from 'react-icons/im'
import { CiCalendarDate, CiLocationOn } from 'react-icons/ci'
import { useDeleteProduct, useGetProducts, usePatchProduct, usePostProduct } from '../../../hooks/products/products'
import { LuFileUp } from 'react-icons/lu'
import SearchPage from '../../../components/searchPage'

function ProductTabs() {
  const [createPayload, setCreatePayload] = useState({
    name:"",
    imageUrl:"",
    isActive:"",
    id:""
  })
  const [isCreateOpen, setIsCreateOpen] = useState(false)
  const [search, setSearch] = useState('')
  const [isViewOpen, setIsViewOpen] = useState(false)
  const onCreateOpen = () => setIsCreateOpen(true)
  const onViewClose = () => setIsViewOpen(false)
  const [image, setImage] = useState({})
  //   const onViewOpen = () => setIsViewOpen(true)
const [isOpenEdit, setIsOpenEdit] = useState(false)
  const [rows, setRows] = useState([])
  const width = window.innerWidth
  const isMobile = width <= 500
  const [form] = Form.useForm()
  
  const onCloseEdit = () => {
    setIsOpenEdit(false)
    form.resetFields();
  }

  const onCreateClose = () => {
    form.resetFields()
    setIsCreateOpen(false)
    setRows([])
  }

const uploadProps = useMemo(() => ({
  name: 'file',
  method: 'GET',
  multiple: false,
  data: image?.file,
  onChange({file, fileList}) {
    setImage({
      file,
      name: file?.name,
      fileObj: file?.originFileObj,
      url: URL.createObjectURL(file?.originFileObj),
    })
  }
}), [image]);

const {
  data: getProductsData,
  refetch: getProductsFetch,
  isFetching: getProductsLoad,
} = useGetProducts(
  {SearchString: search},
  ["SearchString"],
)

const successAction = () => {
  getProductsFetch()
  form.resetFields();
  onCloseEdit()
  onCreateClose()
};

const handleEdit = (d) => {
  setIsOpenEdit(true)
  setCreatePayload({
    name:d?.name,
    inActive:d?.isActive,
    imageUrl: d?.imageUrl,
    id:d?.id
  })
}

  const {
    mutate: postProductAction,
    isLoading: postRoleLoad,
  } = usePostProduct(successAction)
  
  const {
    mutate: putProductAction,
    isLoading: putProductLoad,
  } = usePatchProduct(successAction)

  const {
    mutate: deleteProductAction,
    isLoading: deleteProductLoad,
  } = useDeleteProduct(successAction)

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key:"name",
      render: (e) => <div className='flex items-center gap-3'>
        {/* <Avatar src="">CF</Avatar> */}
        <p className='text-sm font-medium text-dim'>{e}</p>
      </div>,
    },
    {
      title: "Image",
      dataIndex: "imageUrl",
      key:"3",
      render: (e) => 
        <Image src={e} alt='vRV' width={80} />
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key:"isActive",
      render: (e) => 
      <Tag className={`{${e} ? ${statusType?.active?.col} : ${statusType?.inactive?.col}} ${e} ? ${statusType?.active?.bd} : ${statusType?.inactive?.bd}} font-bold rounded-2xl px-3 py-0.5`}>{e ? "ACTIVE" : "INACTIVE"}</Tag>
    },
    {
      title: "Action",
      dataIndex: "",
      render: (data,idx) => <Dropdown
        key={idx}
        trigger={["click"]}
        placement="bottomLeft"
        menu={{items: [
          // {key: "view", icon: <SlEye className='!text-base' />, label: <button id=''>View</button>},
          {key: "edit", label: <button className='flex' id='' onClick={()=>handleEdit(data)}><BiEdit className='!text-base mx-4 py-auto' /> Edit</button>},
          // {key: "delete", icon: <GoTrash className='!text-base mx-4 py-auto' />, label: <button className='flex' onClick={() => handleConfirm({})}>Delete</button>},
          {key: "delete", label: <button className='flex' onClick={() => handleConfirm({data: data?.id, action: deleteProductAction})}><GoTrash className='!text-base mx-4 py-auto' /> Delete</button>},

        ]}}
      >
        <Button loading={deleteProductLoad} className='!bg-[#F2F6FC]' type='text' icon={<PiDotsThreeOutlineBold />} />
      </Dropdown>
    },
  ]

  const onSubmit = (d) => {
    if (!image?.fileObj) {
      notification.error({
        message: "Failed!",
        description: "Please Image is Required",
      })
    }else{
      const payload = {
          name: d.name,
          ImageFile: image?.fileObj,
        }
        postProductAction(payload)
    }
  }

  const onSubmitEdit = () => {
    const isActive = !createPayload.isActive ? true : createPayload.isActive;
    if (!image?.fileObj) {
      const payload = {
        name: createPayload.name,
        id: createPayload.id,
        isActive: isActive,
        ImageFile: createPayload.ImageFile,
      }
      putProductAction(payload)
      console.log(payload, 'here')
    }else{
      const payload = {
        name: createPayload.name,
        id: createPayload.id,
        isActive: isActive,
        ImageFile: image?.fileObj,
      }
      putProductAction(payload)
      console.log(payload, 'nere')
    }
  }

  return (
    <PadContainer loading={getProductsLoad}>
      <TitleContainer
        path={false}
        title="Category Management"
        className="border border-lit rounded-xl"
        action={
        <div className='flex'>
          <SearchPage setSearch={setSearch} size='' />
          <Button onClick={onCreateOpen} className='!bg-light_blue' type='primary' size='large' icon={<FaPlus />}>Add Category</Button>
        </div>
        }
      >
        <CustomTable
          pagination={10}
          column={columns}
          data={getProductsData?.data?.data || []}
          rowSelection={handleTableSelect(rows, setRows, "_id")}
        />
      </TitleContainer>


      {/* create edit drawer */}
      <Drawer
        open={isCreateOpen}
        onClose={onCreateClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>New Category</p>}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onSubmit}
          className='relative'
        >
          <Form.Item label="Name" name="name" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input size='large' placeholder='Name' />
          </Form.Item> 
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCreateClose} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' loading={postRoleLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Save</Button>
          </div>
        </Form>
      </Drawer>

      <Drawer
        open={isOpenEdit}
        onClose={onCloseEdit}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Edit Category</p>}
      >
        
        <Form
          layout="vertical"
          onFinish={onSubmitEdit}
          className='relative'
          form={form}
        >
          <Form.Item label="Name" rules={[{required: true, message: 'Please input Name!',},]}>
            <Input 
                size='large' 
                placeholder='Edit name' 
                prefix={<BiUser />} 
                value={createPayload.name}
                onChange={({target:{value}})=> setCreatePayload({...createPayload, name: value})}
            />
          </Form.Item>          
          <Form.Item>
            <Upload {...uploadProps}>
              <Button block className='!bg-none text-secondary' icon={<LuFileUp className='text-light_blue' />} type='text' size='large'>Upload Image</Button>
            </Upload>
            <Image src={createPayload.imageUrl} alt='image' width={70} />
          </Form.Item>
          <Form.Item label="Status" valuePropName="checked">
            <Switch 
                checkedChildren="active" 
                unCheckedChildren="inactive" 
                defaultChecked                
                value={createPayload.isActive}
                onChange={(checked)=> setCreatePayload({...createPayload, isActive: checked})} 
            />
          </Form.Item>
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={onCloseEdit} className='!text-light_blue !border-light_blue' size='large'>Cancel</Button>
            <Button htmlType='submit' onClick={onSubmitEdit} loading={putProductLoad} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Update</Button>
          </div>
        </Form>
      </Drawer>

      {/* view drawer */}
      <Drawer
        open={isViewOpen}
        onClose={onViewClose}
        width={isMobile ? width : 430}
        title={<p className='text-xl font-bold text-light_blue'>Product</p>}
      >
        <div className='w-full'>
          <div className='flex gap-3 items-center'>
            <Image alt='Product image' src={eventImage} />
            <div className='space-y-3'>
              <p className='text-2xl font-bold text-light_blue'>Kings’s Day Parade</p>
              <Tag className={`${statusType?.info?.bg} ${statusType?.secondary?.col} ${statusType?.info?.bd} font-bold rounded-2xl px-3 py-0.5`}>Active</Tag>
            </div>
          </div>
          <Divider />
          <div className='w-full rounded-xl bg-[#FEFAF2] px-5 divide-y'>
            {[
              {Icon: CiLocationOn, value: "Mandeville"},
              {Icon: ImStopwatch, value: "2pm"},
              {Icon: CiCalendarDate, value: "12 December, 2023"},
            ].map(({Icon, value}) => (
              <div className='flex items-center gap-3 py-5'>
                <Button className='!bg-[#FDE9C2] !text-[#F5A302]' icon={<Icon className="!text-xl" />} shape='circle' size='large' type='primary' />
                <p className='text-lg font-semibold text-silver'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            {[
              {label: "Route From", value: "Lagos"},
              {label: "Route To", value: "Germany"},
              {label: "Category", value: "Music and Entertainment"},
              {label: "Created by", value: "Admin"},
            ].map(({label, value}) => (
              <div className='flex items-center gap-3'>
                <p className='text-base text-light_blue font-semibold'>{label}: </p>
                <p className='text-base text-dim font-medium'>{value}</p>
              </div>
            ))}
          </div>
          <Divider />
          <div className='w-full px-5 flex justify-between items-center'>
            <div className='flex items-center gap-5'>
              <p className='text-base text-light_blue font-semibold'>Attendees:</p>
              <Avatar.Group
                maxCount={4}
                maxPopoverTrigger="click"
                maxStyle={{ color: '#F5A302', backgroundColor: '#002C70', cursor: 'pointer' }}
              >
                {Array.from(Array(100).keys()).map(idx => (
                  <Avatar>{idx}</Avatar>
                ))}
              </Avatar.Group>
            </div>
            <Button className='!bg-lint text-dim' type='primary' size='small'>View All</Button>
          </div>
          <Divider />
          <div className='w-full px-5 space-y-1'>
            <p className='text-base text-light_blue font-semibold'>Description</p>
            <p className='text-sm text-dim font-normal'>Celebrate the vibrant spirit of our community at our annual Parade Spectacular! Join us for a lively and colourful procession weaving through the heart of [City/Town Name], featuring magnificent floats, marching bands, and dazzling performances.</p>
          </div>
          <Divider />
          <div className='grid grid-cols-2 gap-5'>
            <Button onClick={handleEdit} loading={false} className='!bg-light_blue hover:!bg-hover' size='large' type='primary'>Edit</Button>
            <Button className='!text-light_blue !border-light_blue' size='large'>Delete</Button>
          </div>
        </div>
      </Drawer>
    </PadContainer>
  )
}

export default ProductTabs